<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';
import { input } from '../utils/minhaLaisOptions';

const form = defineModel({
  type: Object,
  required: true,
});
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Taxa de serviço na locação">
    <p class="text-[13px] text-lais-text-muted mb-4">
      Define o percentual usado na tabela detalhada de aluguel para a taxa de
      serviço do locatário.
    </p>
    <LaisField label="Percentual (%)" helper="Valor padrão atual: 10%">
      <input
        v-model.number="form.tenant_service_fee_percent"
        type="number"
        min="0"
        step="0.1"
        :class="input"
      />
    </LaisField>
  </LaisCard>
</template>
